/**
 * Client-side JavaScript: Network.
 * Resource visualization, navigation timeline, Network DevTools panel, and failure rendering.
 */
export const JS_NETWORK = `
  /* ── Network Visualization Helpers ── */
  var RES_COLORS={xhr:'#60a5fa',document:'#818cf8',script:'#fbbf24',stylesheet:'#a78bfa',image:'#34d399',font:'#f472b6',other:'#6b7280'};
  var RES_LABELS={xhr:'XHR',document:'Doc',script:'JS',stylesheet:'CSS',image:'Img',font:'Font',other:'Other'};
  var RES_ORDER=['xhr','document','script','stylesheet','image','font','other'];

  function renderResBar(byType,total,mini){
    if(!byType||total===0)return '';
    var h='<div class="net-bar'+(mini?' net-bar--mini':'')+'">';
    for(var i=0;i<RES_ORDER.length;i++){var k=RES_ORDER[i];var cnt=byType[k]||0;if(cnt===0)continue;var pct=(cnt/total*100).toFixed(1);h+='<div class="net-bar-seg" style="width:'+pct+'%;background:'+RES_COLORS[k]+'" title="'+RES_LABELS[k]+': '+cnt+' ('+(cnt/total*100).toFixed(0)+'%)"></div>';}
    h+='</div>';return h;
  }

  function renderResLegend(byType){
    if(!byType)return '';
    var h='<div class="net-bar-legend">';
    for(var i=0;i<RES_ORDER.length;i++){var k=RES_ORDER[i];var cnt=byType[k]||0;if(cnt===0)continue;h+='<span class="net-legend-item"><span class="net-legend-dot" style="background:'+RES_COLORS[k]+'"></span>'+RES_LABELS[k]+' <span class="net-legend-count">'+cnt+'</span></span>';}
    h+='</div>';return h;
  }

  function calcStepTiming(step){
    var t={};
    try{
      if(step.visitedAt&&step.domContentLoadedAt){var dcl=new Date(step.domContentLoadedAt).getTime()-new Date(step.visitedAt).getTime();if(dcl>=0)t.dcl=dcl;}
      if(step.visitedAt&&step.networkIdleAt){var idle=new Date(step.networkIdleAt).getTime()-new Date(step.visitedAt).getTime();if(idle>=0)t.idle=idle;}
    }catch(e){}
    return t;
  }

  function failStatusClass(code){var n=parseInt(code,10);if(n>=400&&n<500)return 'fail-url-badge--4xx';if(n>=500)return 'fail-url-badge--5xx';return 'fail-url-badge--other';}

  function renderFailedUrls(failedUrls){
    if(!failedUrls||failedUrls.length===0)return '';
    var h='<div class="fail-urls">';
    for(var fi=0;fi<failedUrls.length;fi++){
      var furl=failedUrls[fi];var spIdx=furl.indexOf(' ');
      var fStatus=spIdx>0?furl.substring(0,spIdx):'';var fPath=spIdx>0?furl.substring(spIdx+1):furl;
      h+='<div class="fail-url"><span class="fail-url-badge '+failStatusClass(fStatus)+'">'+esc(fStatus)+'</span>'+esc(fPath)+'</div>';
    }
    h+='</div>';return h;
  }

  function renderNetworkPanel(stats){
    if(!stats)return '<div style="padding:7px 12px;font-size:11px;color:var(--fg-2);font-style:italic">No network data</div>';
    var hasFail=stats.failedRequests>0;
    var h='<div class="net-header'+(hasFail?' has-fails':'')+'"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>Network</div>';
    h+='<div class="net-stats-row"><div class="net-stat"><span class="nv">'+stats.totalRequests+'</span><span class="nl">Requests</span></div><div class="net-stat'+(hasFail?' net-fail':'')+'"><span class="nv">'+stats.failedRequests+'</span><span class="nl">Failed</span></div><div class="net-stat"><span class="nv">'+fmtBytes(stats.totalBytes)+'</span><span class="nl">Transfer</span></div></div>';
    if(stats.byType&&stats.totalRequests>0){h+='<div class="net-bar-wrap">'+renderResBar(stats.byType,stats.totalRequests,false)+'</div>';h+=renderResLegend(stats.byType);}
    if(hasFail&&stats.failedRequestUrls&&stats.failedRequestUrls.length>0)h+=renderFailedUrls(stats.failedRequestUrls);
    return h;
  }

  function renderNavTimeline(steps){
    if(!steps||steps.length===0)return '';
    var h='<div class="nav-timeline">';
    for(var i=0;i<steps.length;i++){
      var s=steps[i];var hasNetFail=s.networkStats&&s.networkStats.failedRequests>0;
      h+='<div class="nav-step"><div class="step-connector"><div class="step-node '+(hasNetFail?'node-warn':'node-ok')+'">'+(i+1)+'</div>';
      if(i<steps.length-1)h+='<div class="step-line"></div>';
      h+='</div><div class="step-content"><div class="step-header" data-step="'+i+'"><span class="step-url" title="'+esc(s.url)+'">'+esc(s.url)+'</span><span class="nav-badge nb-'+s.navigationType+'">'+esc(s.navigationType.replace(/_/g,' '))+'</span><span class="step-meta"><span>'+fmtDur(s.duration)+'</span>';
      if(s.networkStats)h+=' <span style="color:var(--fg-2)">'+s.networkStats.totalRequests+' req</span>';
      h+='</span></div><div class="step-detail" id="step-detail-'+i+'">'+renderNetworkPanel(s.networkStats)+'</div></div></div>';
    }
    h+='</div>';return h;
  }

  /* ── Network DevTools Panel ── */
  function ndtStatusClass(code){var n=parseInt(code,10);if(n===0)return 'ndt-status--0';if(n<300)return 'ndt-status--2xx';if(n<400)return 'ndt-status--3xx';if(n<500)return 'ndt-status--4xx';return 'ndt-status--5xx';}
  function urlPath(u){try{var p=new URL(u);return p.pathname+p.search;}catch(e){return u;}}
  function prettyBody(body,ct){
    if(!body)return null;
    if(ct&&(ct.indexOf('json')>=0||ct.indexOf('javascript')>=0)){try{return JSON.stringify(JSON.parse(body),null,2);}catch(e){}}
    return body;
  }

  function renderNdtHeaders(headers,label,emptyMsg){
    if(!headers)return '<div class="ndt-body-empty">'+(emptyMsg||('No '+label+' headers captured'))+'</div>';
    var keys=[];for(var k in headers){if(headers.hasOwnProperty(k))keys.push(k);}
    if(keys.length===0)return '<div class="ndt-body-empty">'+(emptyMsg||('No '+label+' headers captured'))+'</div>';
    keys.sort();
    var h='<table class="ndt-headers-tbl"><thead><tr><th>Name</th><th>Value</th></tr></thead><tbody>';
    for(var i=0;i<keys.length;i++){h+='<tr><td>'+esc(keys[i])+'</td><td>'+esc(headers[keys[i]])+'</td></tr>';}
    h+='</tbody></table>';return h;
  }

  function renderNdtBody(body,truncated,isBinary,ct,emptyLabel){
    if(isBinary)return '<div class="ndt-body-empty">Binary content — not displayed</div>';
    if(!body)return '<div class="ndt-body-empty">'+emptyLabel+'</div>';
    var pretty=prettyBody(body,ct);
    var h='<div class="ndt-body-wrap"><pre class="ndt-body-pre">'+esc(pretty||body)+'</pre>';
    if(truncated)h+='<span class="ndt-body-truncated">Body truncated</span>';
    h+='</div>';return h;
  }

  function renderNdtDetail(req,idx){
    var did='ndt-d-'+idx;
    var h='<div class="ndt-detail" id="'+did+'">';
    h+='<div class="ndt-detail-tabs">';
    h+='<button class="ndt-detail-tab active" data-ndt-tab="general" data-ndt-target="'+did+'">General</button>';
    h+='<button class="ndt-detail-tab" data-ndt-tab="req-headers" data-ndt-target="'+did+'">Request Headers</button>';
    h+='<button class="ndt-detail-tab" data-ndt-tab="req-body" data-ndt-target="'+did+'">Payload</button>';
    h+='<button class="ndt-detail-tab" data-ndt-tab="res-headers" data-ndt-target="'+did+'">Response Headers</button>';
    h+='<button class="ndt-detail-tab" data-ndt-tab="res-body" data-ndt-target="'+did+'">Response</button>';
    h+='</div>';

    /* General tab */
    h+='<div class="ndt-detail-pane active" data-ndt-pane="general">';
    h+='<div class="ndt-general">';
    h+='<span class="ndt-general-k">Request URL</span><span class="ndt-general-v">'+esc(req.url)+'</span>';
    h+='<span class="ndt-general-k">Method</span><span class="ndt-general-v">'+esc(req.method)+'</span>';
    h+='<span class="ndt-general-k">Status Code</span><span class="ndt-general-v'+(req.statusCode>=400||req.statusCode===0?' ndt-err':'')+'">'+req.statusCode+(req.error?' ('+esc(req.error)+')':'')+'</span>';
    h+='<span class="ndt-general-k">Resource Type</span><span class="ndt-general-v">'+esc(req.resourceType)+'</span>';
    if(req.contentType)h+='<span class="ndt-general-k">Content-Type</span><span class="ndt-general-v">'+esc(req.contentType)+'</span>';
    h+='<span class="ndt-general-k">Response Size</span><span class="ndt-general-v">'+fmtBytes(req.responseSize||0)+'</span>';
    h+='<span class="ndt-general-k">Response Time</span><span class="ndt-general-v">'+fmtDur(req.responseTimeMs)+'</span>';
    if(req.startedAt)h+='<span class="ndt-general-k">Started At</span><span class="ndt-general-v">'+fmtDate(req.startedAt)+'</span>';
    if(req.error)h+='<span class="ndt-general-k">Error</span><span class="ndt-general-v ndt-err">'+esc(req.error)+'</span>';
    h+='</div></div>';

    /* Request Headers tab */
    h+='<div class="ndt-detail-pane" data-ndt-pane="req-headers">'+renderNdtHeaders(req.requestHeaders,'request')+'</div>';

    /* Payload tab (request body) */
    h+='<div class="ndt-detail-pane" data-ndt-pane="req-body">'+renderNdtBody(req.requestBody,req.requestBodyTruncated,false,req.contentType,'No request body')+'</div>';

    /* Response Headers tab */
    h+='<div class="ndt-detail-pane" data-ndt-pane="res-headers">'+renderNdtHeaders(req.responseHeaders,'response')+'</div>';

    /* Response tab */
    h+='<div class="ndt-detail-pane" data-ndt-pane="res-body">'+renderNdtBody(req.responseBody,req.responseBodyTruncated,req.isBinary,req.contentType,'No response body captured')+'</div>';

    h+='</div>';return h;
  }

  var NDT_ROW_H=32;
  var NDT_DETAIL_H=280;
  var NDT_VBUF=30;

  function ndtVideoOffset(req,baseTime){
    if(!baseTime||!req.startedAt)return -1;
    var t=Date.parse(req.startedAt);
    if(isNaN(t))return -1;
    var off=(t-baseTime)/1000;
    return off>=0?off:-1;
  }

  function renderNetworkDevTools(reqs,hasVideo,baseTime,pageMeta){
    if(!reqs||reqs.length===0)return '<div class="artifact-empty">No network requests captured</div>';
    var uid='ndt-'+Math.random().toString(36).substr(2,6);
    var h='<div class="ndt" id="'+uid+'">';

    /* Toolbar with type filters and search */
    h+='<div class="ndt-toolbar">';
    h+='<div class="ndt-filter">';
    h+='<button class="ndt-filter-btn active" data-ndt-filter="all">All</button>';
    var types=['xhr','document','script','stylesheet','image','font','other'];
    var typeLabels={xhr:'XHR',document:'Doc',script:'JS',stylesheet:'CSS',image:'Img',font:'Font',other:'Other'};
    for(var ti=0;ti<types.length;ti++){
      var cnt=0;for(var ci=0;ci<reqs.length;ci++){if(reqs[ci].resourceType===types[ti])cnt++;}
      if(cnt>0)h+='<button class="ndt-filter-btn" data-ndt-filter="'+types[ti]+'">'+typeLabels[types[ti]]+' <span style="opacity:.6">'+cnt+'</span></button>';
    }
    h+='</div>';
    h+='<input class="ndt-search" placeholder="Filter URLs..." data-ndt-search="'+uid+'">';
    h+='<span class="ndt-count" data-ndt-count="'+uid+'">'+reqs.length+' requests</span>';
    h+='</div>';

    /* Virtualized request list */
    h+='<div class="ndt-list ndt-vlist" data-ndt-list="'+uid+'" data-ndt-uid="'+uid+'" style="overflow-y:auto;max-height:400px;position:relative">';
    h+='<div class="ndt-vspacer" style="height:'+(reqs.length*NDT_ROW_H)+'px;position:relative"></div>';
    h+='</div></div>';

    /* Pre-compute video offsets */
    var ndtVideoOffsets=[];
    if(hasVideo&&baseTime){
      for(var noi=0;noi<reqs.length;noi++){ndtVideoOffsets.push(ndtVideoOffset(reqs[noi],baseTime));}
    }

    /* Store reqs data for virtual rendering */
    setTimeout(function(){
      var el=document.getElementById(uid);if(!el)return;
      var list=el.querySelector('.ndt-vlist');if(!list)return;
      var spacer=list.querySelector('.ndt-vspacer');
      var allReqs=reqs;
      var filteredIdxs=null;
      var openIdx=-1;
      var openTab='general';
      var highlightIdx=-1;

      function getVisible(){return filteredIdxs||allReqs.map(function(_,i){return i});}

      var lastDetailH=NDT_DETAIL_H;
      var NDT_TABS=['general','req-headers','req-body','res-headers','res-body'];

      function renderDetailWithTab(r,ri,activeTab){
        var html=renderNdtDetail(r,ri);
        /* Replace the default active tab/pane with the tracked one */
        if(activeTab&&activeTab!=='general'){
          /* Remove default active from general tab button and pane */
          html=html.replace('data-ndt-tab="general" data-ndt-target','data-ndt-tab="general" data-ndt-target');
          /* Swap active classes: remove from general, add to activeTab */
          var parts=html;
          /* Tabs: remove active from all, add to target */
          for(var t=0;t<NDT_TABS.length;t++){
            var tn=NDT_TABS[t];
            var isAct=tn===activeTab;
            parts=parts.replace(new RegExp('class="ndt-detail-tab'+(tn==='general'?' active':'')+'" data-ndt-tab="'+tn+'"'),'class="ndt-detail-tab'+(isAct?' active':'')+'" data-ndt-tab="'+tn+'"');
          }
          /* Panes: remove active from all, add to target */
          for(var p=0;p<NDT_TABS.length;p++){
            var pn=NDT_TABS[p];
            var isPAct=pn===activeTab;
            parts=parts.replace(new RegExp('class="ndt-detail-pane'+(pn==='general'?' active':'')+'" data-ndt-pane="'+pn+'"'),'class="ndt-detail-pane'+(isPAct?' active':'')+'" data-ndt-pane="'+pn+'"');
          }
          html=parts;
        }
        return html.replace('class="ndt-detail"','class="ndt-detail show"');
      }

      function paint(){
        var vis=getVisible();
        /* Find the visual index of the open row (if any) */
        var openVi=-1;
        if(openIdx>=0){for(var oi=0;oi<vis.length;oi++){if(vis[oi]===openIdx){openVi=oi;break;}}}
        var detailExtra=openVi>=0?lastDetailH:0;
        var totalH=vis.length*NDT_ROW_H+detailExtra;
        spacer.style.height=totalH+'px';
        var st=list.scrollTop;var vh=list.clientHeight;
        var startRow=Math.max(0,Math.floor(st/NDT_ROW_H)-NDT_VBUF);
        var endRow=Math.min(vis.length,Math.ceil((st+vh+detailExtra)/NDT_ROW_H)+NDT_VBUF);
        var out='';
        for(var vi=startRow;vi<endRow;vi++){
          var ri=vis[vi];var r=allReqs[ri];
          var isFail=r.statusCode>=400||r.statusCode===0;
          var isOpen=ri===openIdx;
          var isActive=ri===highlightIdx;
          var off=ndtVideoOffsets[ri];
          var seekable=off>=0;
          /* Rows after the open row shift down by the detail panel height */
          var rowTop=vi*NDT_ROW_H+(openVi>=0&&vi>openVi?lastDetailH:0);
          out+='<div class="ndt-row'+(isFail?' ndt-row--fail':'')+(isOpen?' ndt-row--open':'')+(seekable?' seekable':'')+(isActive?' ndt-row--active':'')+'" data-ndt-idx="'+ri+'" data-ndt-type="'+esc(r.resourceType)+'" data-ndt-url="'+esc(r.url.toLowerCase())+'"'+(seekable?' data-offset="'+off.toFixed(2)+'"':'')+' style="position:absolute;top:'+rowTop+'px;left:0;right:0;height:'+NDT_ROW_H+'px">';
          out+='<span class="ndt-status '+ndtStatusClass(r.statusCode)+'">'+r.statusCode+'</span>';
          out+='<span class="ndt-method">'+esc(r.method)+'</span>';
          out+='<span class="ndt-url" title="'+esc(r.url)+'">'+esc(urlPath(r.url))+'</span>';
          out+='<span class="ndt-type">'+esc(RES_LABELS[r.resourceType]||r.resourceType)+'</span>';
          out+='<span class="ndt-size">'+fmtBytes(r.responseSize||0)+'</span>';
          if(seekable){out+='<span class="ndt-time ndt-offset">'+off.toFixed(1)+'s</span>';}
          else{out+='<span class="ndt-time">'+fmtDur(r.responseTimeMs)+'</span>';}
          out+='</div>';
          if(isOpen){out+='<div style="position:absolute;top:'+(rowTop+NDT_ROW_H)+'px;left:0;right:0;z-index:1" class="ndt-detail-wrap">'+renderDetailWithTab(r,ri,openTab)+'</div>';}
        }
        spacer.innerHTML=out;
        /* Measure actual detail height and adjust layout without full repaint */
        if(openVi>=0){
          var detailWrap=spacer.querySelector('.ndt-detail-wrap');
          if(detailWrap){
            var measuredH=detailWrap.offsetHeight;
            if(measuredH>0&&Math.abs(measuredH-lastDetailH)>2){
              lastDetailH=measuredH;
              /* Update spacer height and row positions without re-rendering */
              var newTotalH=vis.length*NDT_ROW_H+lastDetailH;
              spacer.style.height=newTotalH+'px';
              var rows=spacer.querySelectorAll('.ndt-row');
              for(var rr=0;rr<rows.length;rr++){
                var rrIdx=parseInt(rows[rr].getAttribute('data-ndt-idx'),10);
                /* Find visual index for this row */
                for(var rv=startRow;rv<endRow;rv++){if(vis[rv]===rrIdx){
                  if(rv>openVi){rows[rr].style.top=(rv*NDT_ROW_H+lastDetailH)+'px';}
                  break;
                }}
              }
              detailWrap.style.top=((openVi*NDT_ROW_H)+NDT_ROW_H)+'px';
            }
          }
        }
        var countEl=el.querySelector('.ndt-count');
        if(countEl)countEl.textContent=vis.length+(vis.length!==allReqs.length?' / '+allReqs.length:'')+' requests';
      }

      var rafPending=false;
      /* Infinite scroll: pagination state */
      var _pgTestId=pageMeta&&pageMeta.testId?pageMeta.testId:null;
      var _pgPage=pageMeta&&pageMeta.page?pageMeta.page:1;
      var _pgTotal=pageMeta&&pageMeta.total?pageMeta.total:allReqs.length;
      var _pgPageSize=pageMeta&&pageMeta.pageSize?pageMeta.pageSize:500;
      var _pgLoading=false;

      function updateFilterBtns(){
        var filterDiv=el.querySelector('.ndt-filter');if(!filterDiv)return;
        var activeFilter='all';
        var activeBtn=filterDiv.querySelector('.ndt-filter-btn.active');
        if(activeBtn)activeFilter=activeBtn.getAttribute('data-ndt-filter')||'all';
        var btnH='<button class="ndt-filter-btn'+(activeFilter==='all'?' active':'')+'" data-ndt-filter="all">All</button>';
        var types=['xhr','document','script','stylesheet','image','font','other'];
        var typeLabels={xhr:'XHR',document:'Doc',script:'JS',stylesheet:'CSS',image:'Img',font:'Font',other:'Other'};
        for(var ti=0;ti<types.length;ti++){
          var cnt=0;for(var ci=0;ci<allReqs.length;ci++){if(allReqs[ci].resourceType===types[ti])cnt++;}
          if(cnt>0)btnH+='<button class="ndt-filter-btn'+(activeFilter===types[ti]?' active':'')+'" data-ndt-filter="'+types[ti]+'">'+typeLabels[types[ti]]+' <span style="opacity:.6">'+cnt+'</span></button>';
        }
        filterDiv.innerHTML=btnH;
      }

      function loadNextPage(){
        if(_pgLoading||!_pgTestId)return;
        if(allReqs.length>=_pgTotal)return;
        _pgLoading=true;
        var fetchData=window.__trFetchTestData;
        if(!fetchData){_pgLoading=false;return;}
        fetchData(_pgTestId,'network',_pgPage+1,_pgPageSize,function(err,result){
          _pgLoading=false;
          if(err||!result||!result.items)return;
          _pgPage++;
          for(var i=0;i<result.items.length;i++){
            allReqs.push(result.items[i]);
            if(hasVideo&&baseTime){ndtVideoOffsets.push(ndtVideoOffset(result.items[i],baseTime));}
          }
          _pgTotal=result.total;
          /* Re-apply filter to include new items */
          if(filteredIdxs!==null){
            var filterDiv=el.querySelector('.ndt-filter');
            var activeBtn=filterDiv?filterDiv.querySelector('.ndt-filter-btn.active'):null;
            var ft=activeBtn?activeBtn.getAttribute('data-ndt-filter'):'all';
            var searchEl=el.querySelector('.ndt-search');
            var q=searchEl?searchEl.value.toLowerCase():'';
            if(ft&&ft!=='all'||q){
              filteredIdxs=[];
              for(var fi=0;fi<allReqs.length;fi++){
                var r=allReqs[fi];
                if(ft&&ft!=='all'&&r.resourceType!==ft)continue;
                if(q&&r.url.toLowerCase().indexOf(q)<0)continue;
                filteredIdxs.push(fi);
              }
            }else{filteredIdxs=null;}
          }
          updateFilterBtns();
          paint();
        });
      }

      list.addEventListener('scroll',function(){
        if(!rafPending){rafPending=true;requestAnimationFrame(function(){rafPending=false;paint();});}
        /* Infinite scroll: load more when near bottom */
        if(list.scrollTop+list.clientHeight>=list.scrollHeight-200){loadNextPage();}
      },{passive:true});

      /* Click handler for rows */
      list.addEventListener('click',function(e){
        var tab=e.target.closest('.ndt-detail-tab');
        if(tab){
          /* Handle tab switch within detail panel — DOM-only, no repaint */
          e.stopPropagation();
          var tgt=tab.getAttribute('data-ndt-target');
          var pane=tab.getAttribute('data-ndt-tab');
          openTab=pane;
          var det=document.getElementById(tgt);
          if(det){
            var tabs=det.querySelectorAll('.ndt-detail-tab');
            for(var ti=0;ti<tabs.length;ti++)tabs[ti].classList.remove('active');
            tab.classList.add('active');
            var panes=det.querySelectorAll('.ndt-detail-pane');
            for(var pi=0;pi<panes.length;pi++)panes[pi].classList.remove('active');
            var tp=det.querySelector('[data-ndt-pane="'+pane+'"]');
            if(tp)tp.classList.add('active');
            /* Re-measure after tab switch since pane height may differ */
            requestAnimationFrame(function(){
              var detailWrap=spacer.querySelector('.ndt-detail-wrap');
              if(detailWrap){
                var mh=detailWrap.offsetHeight;
                if(mh>0&&Math.abs(mh-lastDetailH)>2){
                  lastDetailH=mh;
                  /* Adjust layout without full repaint to preserve tab state */
                  var vis=getVisible();
                  var ovi=-1;
                  for(var oi=0;oi<vis.length;oi++){if(vis[oi]===openIdx){ovi=oi;break;}}
                  spacer.style.height=(vis.length*NDT_ROW_H+lastDetailH)+'px';
                  var rows=spacer.querySelectorAll('.ndt-row');
                  for(var rr=0;rr<rows.length;rr++){
                    var rrIdx=parseInt(rows[rr].getAttribute('data-ndt-idx'),10);
                    for(var rv=0;rv<vis.length;rv++){if(vis[rv]===rrIdx){
                      if(rv>ovi){rows[rr].style.top=(rv*NDT_ROW_H+lastDetailH)+'px';}
                      break;
                    }}
                  }
                }
              }
            });
          }
          return;
        }
        var row=e.target.closest('.ndt-row');if(!row)return;
        e.stopPropagation();
        var idx=parseInt(row.getAttribute('data-ndt-idx'),10);
        openIdx=openIdx===idx?-1:idx;
        openTab='general';
        lastDetailH=NDT_DETAIL_H;
        paint();
      });

      /* Store filter/search handler on element */
      el.__ndtFilter=function(filterType,searchVal){
        var q=(searchVal||'').toLowerCase();
        if((!filterType||filterType==='all')&&!q){filteredIdxs=null;}
        else{
          filteredIdxs=[];
          for(var i=0;i<allReqs.length;i++){
            var r=allReqs[i];
            if(filterType&&filterType!=='all'&&r.resourceType!==filterType)continue;
            if(q&&r.url.toLowerCase().indexOf(q)<0)continue;
            filteredIdxs.push(i);
          }
        }
        openIdx=-1;
        list.scrollTop=0;
        paint();
      };

      /* Video sync: scroll to matching request by time */
      if(ndtVideoOffsets.length){
        el.__videoSync=function(seconds){
          var vis=getVisible();
          var matchVi=-1;
          for(var i=vis.length-1;i>=0;i--){
            if(ndtVideoOffsets[vis[i]]>=0&&ndtVideoOffsets[vis[i]]<=seconds){matchVi=i;break;}
          }
          if(matchVi<0){highlightIdx=-1;paint();return;}
          var newHL=vis[matchVi];
          if(newHL===highlightIdx)return;
          highlightIdx=newHL;
          var syncOpenVi=-1;
          if(openIdx>=0){var svis=getVisible();for(var si=0;si<svis.length;si++){if(svis[si]===openIdx){syncOpenVi=si;break;}}}
          var rowTop=matchVi*NDT_ROW_H+(syncOpenVi>=0&&matchVi>syncOpenVi?lastDetailH:0);
          var vh=list.clientHeight;
          if(rowTop<list.scrollTop||rowTop>list.scrollTop+vh-NDT_ROW_H){
            list.scrollTop=rowTop-vh/2;
          }
          paint();
        };
      }

      paint();
    },0);
    return h;
  }

  function renderTimelineColumn(steps,networkRequests,consoleLogs,testType,hasVideo,baseTime,pageMeta){
    if(!steps||steps.length===0)return '<div class="artifact-empty">No navigation data</div>';
    var hasReqs=networkRequests&&networkRequests.length>0;
    var hasCLogs=consoleLogs&&consoleLogs.length>0;
    var totalNet=pageMeta&&pageMeta.total?pageMeta.total:(hasReqs?networkRequests.length:0);
    var h='<div class="seg-ctrl" data-seg-group="right-panel">';
    h+='<button class="seg-btn active" data-seg="timeline"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>Timeline ('+steps.length+')</button>';
    if(hasCLogs)h+='<button class="seg-btn" data-seg="console"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="4 17 10 11 4 5"/><line x1="12" y1="19" x2="20" y2="19"/></svg>Console ('+consoleLogs.length+')</button>';
    h+='<button class="seg-btn" data-seg="network"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>Network'+(totalNet?' ('+totalNet+')':'')+'</button>';
    h+='</div>';
    h+='<div class="seg-pane active" data-seg-pane="timeline">'+renderNavTimeline(steps)+'</div>';
    if(hasCLogs)h+='<div class="seg-pane" data-seg-pane="console">'+renderConsoleColumn(consoleLogs,testType,hasVideo,baseTime)+'</div>';
    h+='<div class="seg-pane" data-seg-pane="network">'+renderNetworkDevTools(networkRequests,hasVideo,baseTime,pageMeta)+'</div>';
    return h;
  }

  function renderFailure(failure,filePath,testName,tags){
    if(!failure)return '';
    var sid='s-'+Math.random().toString(36).substr(2,8);
    var cpid='cp-'+Math.random().toString(36).substr(2,8);
    var h='<div class="failure-panel"><div class="failure-panel-header"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M15 9l-6 6M9 9l6 6"/></svg>Failure Details<button class="copy-prompt-btn" id="'+cpid+'"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg>Copy Prompt</button></div>';
    h+='<div class="failure-message">'+esc(stripAnsi(failure.message))+'</div>';
    if(failure.code)h+=renderCodeSnippet(failure.code);
    if(failure.line!==null&&failure.line!==undefined)h+='<div class="line-marker">Line '+failure.line+'</div>';
    if(failure.stack){h+='<button class="stack-toggle-btn" data-stack="'+sid+'">Show stack trace</button><div class="stack-trace" id="'+sid+'">'+esc(stripAnsi(failure.stack))+'</div>';}
    h+='</div>';
    /* Wire up Copy Prompt button after render */
    setTimeout(function(){
      var btn=document.getElementById(cpid);
      if(!btn)return;
      btn.addEventListener('click',function(e){
        e.stopPropagation();
        var nl=String.fromCharCode(10);
        var ticks=String.fromCharCode(96,96,96);
        var msg=failure.message?stripAnsi(failure.message):'Unknown error';
        var tname=testName||'Unknown test';
        var tline=(failure.line!==null&&failure.line!==undefined)?String(failure.line):'unknown';
        var ttags=(tags&&tags.length>0)?tags.join(', '):'none';
        var fp=filePath||'unknown';
        /* Escape regex special chars in test name for --grep */
        function escGrep(s){return s.replace(/[.*+?^]/g,'\\\\$&').replace(/[()]/g,'\\\\$&');}
        var tnameEsc=escGrep(tname);
        var p='You are a Playwright test repair agent. A test in this codebase has failed. Your job is to fix the code and verify the fix passes.'+nl+nl;
        p+='## Failed Test'+nl+nl;
        p+='- **File:** '+fp+nl;
        p+='- **Test Name:** '+tname+nl;
        p+='- **Line:** '+tline+nl;
        p+='- **Tags:** '+ttags+nl+nl;
        p+='## Error'+nl+nl;
        p+=msg+nl+nl;
        if(failure.code){
          p+='## Failing Code'+nl+nl;
          p+=ticks+'typescript'+nl+stripAnsi(failure.code)+nl+ticks+nl+nl;
        }
        if(failure.stack){
          p+='## Stack Trace'+nl+nl;
          p+=ticks+nl+stripAnsi(failure.stack)+nl+ticks+nl+nl;
        }
        p+='## Your Task'+nl+nl;
        p+='1. Analyze the error and identify the root cause'+nl;
        p+='2. Edit '+ticks+fp+ticks+' to fix the failing assertion or logic '+String.fromCharCode(8212)+' do not delete the test'+nl;
        p+='3. Run the specific test to verify the fix: '+ticks+'npx playwright test '+fp+' --grep "'+tnameEsc+'" --reporter=line'+ticks+nl;
        p+='4. If the test passes, run the full file to confirm no regressions: '+ticks+'npx playwright test '+fp+' --reporter=line'+ticks+nl;
        p+='5. Stop only when the test exits with status '+ticks+'passed'+ticks+nl+nl;
        p+='## Constraints'+nl+nl;
        p+='- Only modify '+ticks+fp+ticks+nl;
        p+='- Do not alter shared fixtures, helpers, or '+ticks+'playwright.config.ts'+ticks+nl;
        p+='- Do not skip or remove the test'+nl;
        navigator.clipboard.writeText(p).then(function(){
          btn.innerHTML='<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17l-5-5"/></svg>Copied!';
          btn.classList.add('copied');
          setTimeout(function(){btn.innerHTML='<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg>Copy Prompt';btn.classList.remove('copied');},2000);
        });
      });
    },0);
    return h;
  }

  /* ── Network DevTools Filter Logic ── */
  /* ── API Calls Column (for API-only tests) ── */
  var API_METHOD_COLORS={GET:'#60a5fa',POST:'#34d399',PUT:'#fbbf24',PATCH:'#a78bfa',DELETE:'#f87171',HEAD:'#6b7280',OPTIONS:'#6b7280'};

  function renderApiCallDetail(ac,idx){
    var did='ndt-d-api-'+idx;
    var reqHeaders=ac.requestHeaders||null;
    var reqBody=ac.requestBody||null;
    var resHeaders=ac.responseHeaders||null;
    var resBody=ac.responseBody||null;
    var ct=(resHeaders&&resHeaders['content-type'])?resHeaders['content-type']:'';
    var reqBodyStr=(reqBody!==null&&reqBody!==undefined)?((typeof reqBody==='string')?reqBody:JSON.stringify(reqBody,null,2)):null;
    var resBodyStr=(resBody!==null&&resBody!==undefined)?((typeof resBody==='string')?resBody:JSON.stringify(resBody,null,2)):null;

    var h='<div class="ndt-detail" id="'+did+'">';
    h+='<div class="ndt-detail-tabs">';
    h+='<button class="ndt-detail-tab active" data-ndt-tab="general" data-ndt-target="'+did+'">General</button>';
    h+='<button class="ndt-detail-tab" data-ndt-tab="req-headers" data-ndt-target="'+did+'">Request Headers</button>';
    h+='<button class="ndt-detail-tab" data-ndt-tab="req-body" data-ndt-target="'+did+'">Payload</button>';
    h+='<button class="ndt-detail-tab" data-ndt-tab="res-headers" data-ndt-target="'+did+'">Response Headers</button>';
    h+='<button class="ndt-detail-tab" data-ndt-tab="res-body" data-ndt-target="'+did+'">Response</button>';
    h+='</div>';

    /* General tab */
    h+='<div class="ndt-detail-pane active" data-ndt-pane="general"><div class="ndt-general">';
    h+='<span class="ndt-general-k">Request URL</span><span class="ndt-general-v">'+esc(ac.url)+'</span>';
    h+='<span class="ndt-general-k">Method</span><span class="ndt-general-v">'+esc(ac.method)+'</span>';
    var sc=ac.responseStatusCode!=null?ac.responseStatusCode:0;
    var st=ac.responseStatusText||'';
    h+='<span class="ndt-general-k">Status Code</span><span class="ndt-general-v'+(sc>=400?' ndt-err':'')+'">'+sc+(st?' '+esc(st):'')+'</span>';
    h+='<span class="ndt-general-k">Response Time</span><span class="ndt-general-v">'+(ac.responseTimeMs!=null?fmtDur(ac.responseTimeMs):'N/A')+'</span>';
    if(ac.timestamp)h+='<span class="ndt-general-k">Timestamp</span><span class="ndt-general-v">'+fmtDate(ac.timestamp)+'</span>';
    h+='</div></div>';

    h+='<div class="ndt-detail-pane" data-ndt-pane="req-headers">'+renderNdtHeaders(reqHeaders,'request','Request headers not available &mdash; only explicitly passed headers are captured for API tests')+'</div>';
    h+='<div class="ndt-detail-pane" data-ndt-pane="req-body">'+renderNdtBody(reqBodyStr,false,false,ct,'No request body')+'</div>';
    h+='<div class="ndt-detail-pane" data-ndt-pane="res-headers">'+renderNdtHeaders(resHeaders,'response')+'</div>';
    h+='<div class="ndt-detail-pane" data-ndt-pane="res-body">'+renderNdtBody(resBodyStr,false,false,ct,'No response body captured')+'</div>';
    h+='</div>';
    return h;
  }

  function renderApiCallsColumn(apiCalls){
    if(!apiCalls||apiCalls.length===0)return '<div class="artifact-empty">No API calls captured</div>';
    var uid='api-'+Math.random().toString(36).substr(2,6);
    var h='<div class="ndt" id="'+uid+'">';

    /* Toolbar */
    h+='<div class="ndt-toolbar"><div class="ndt-filter">';
    h+='<button class="ndt-filter-btn active" data-ndt-filter="all">All</button>';
    var methodCounts={};
    for(var mi=0;mi<apiCalls.length;mi++){var m=apiCalls[mi].method;methodCounts[m]=(methodCounts[m]||0)+1;}
    var methodKeys=[];for(var mk in methodCounts){if(methodCounts.hasOwnProperty(mk))methodKeys.push(mk);}
    methodKeys.sort();
    for(var ki=0;ki<methodKeys.length;ki++){var mk=methodKeys[ki];h+='<button class="ndt-filter-btn" data-ndt-filter="'+mk+'">'+mk+' <span style="opacity:.6">'+methodCounts[mk]+'</span></button>';}
    h+='</div>';
    h+='<input class="ndt-search" placeholder="Filter URLs..." data-ndt-search="'+uid+'">';
    h+='<span class="ndt-count" data-ndt-count="'+uid+'">'+apiCalls.length+' API calls</span>';
    h+='</div>';

    /* Request list */
    h+='<div class="ndt-list" data-ndt-list="'+uid+'">';
    for(var i=0;i<apiCalls.length;i++){
      var ac=apiCalls[i];
      var sc=ac.responseStatusCode!=null?ac.responseStatusCode:0;
      var isFail=sc>=400||sc===0;
      h+='<div class="ndt-row'+(isFail?' ndt-row--fail':'')+'" data-ndt-idx="api-'+i+'" data-ndt-type="'+esc(ac.method)+'" data-ndt-url="'+esc(ac.url.toLowerCase())+'">';
      h+='<span class="ndt-status '+ndtStatusClass(sc)+'">'+sc+'</span>';
      h+='<span class="ndt-method" style="color:'+(API_METHOD_COLORS[ac.method]||'#6b7280')+'">'+esc(ac.method)+'</span>';
      h+='<span class="ndt-url" title="'+esc(ac.url)+'">'+esc(urlPath(ac.url))+'</span>';
      h+='<span class="ndt-type"></span>';
      h+='<span class="ndt-size"></span>';
      h+='<span class="ndt-time">'+(ac.responseTimeMs!=null?fmtDur(ac.responseTimeMs):'')+'</span>';
      h+='</div>';
      h+=renderApiCallDetail(ac,i);
    }
    h+='</div></div>';
    return h;
  }

  function ndtApplyFilters(ndt,filterType,searchVal){
    /* Use virtual filter handler if available */
    if(ndt.__ndtFilter){
      var searchInput=ndt.querySelector('.ndt-search');
      var q=(searchVal!==null&&searchVal!==undefined)?searchVal:(searchInput?searchInput.value:'');
      ndt.__ndtFilter(filterType,q);
      return;
    }
    /* Fallback for non-virtual lists (API calls panel) */
    var list=ndt.querySelector('.ndt-list');if(!list)return;
    var searchInput=ndt.querySelector('.ndt-search');
    var q=(searchVal!==null&&searchVal!==undefined)?searchVal:(searchInput?searchInput.value:'');
    q=q.toLowerCase();
    var rows=list.querySelectorAll('.ndt-row');
    var visible=0;
    for(var i=0;i<rows.length;i++){
      var row=rows[i];
      var type=row.getAttribute('data-ndt-type');
      var url=row.getAttribute('data-ndt-url')||'';
      var show=true;
      if(filterType&&filterType!=='all'&&type!==filterType)show=false;
      if(show&&q&&url.indexOf(q)<0)show=false;
      row.style.display=show?'':'none';
      var det=row.nextElementSibling;
      if(det&&det.classList.contains('ndt-detail')){if(!show){det.classList.remove('show');row.classList.remove('ndt-row--open');}}
      if(show)visible++;
    }
    var countEl=ndt.querySelector('.ndt-count');
    if(countEl)countEl.textContent=visible+' / '+rows.length+' requests';
  }
`;
